import PropTypes from 'prop-types'
import React from 'react'
import { Row, Col } from 'react-flexbox-grid'

const propTypes = {
  nodes: PropTypes.array,
  cols: PropTypes.oneOf([2, 3, 4, 6, 12]),
  xsCols: PropTypes.oneOf([2, 3, 4, 6, 12]),
}

const defaultProps = {
  xsCols: 1,
}

export const ItemRow = ({ nodes, cols, xsCols }) => {
  const pairsOfNodes = nodes.reduce((pairs, item, i) => {
    if (i % cols === 0) {
      pairs.push([])
    }

    pairs[pairs.length - 1].push(item)
    return pairs
  }, [])

  const width = 12 / cols
  const xsWidth = 12 / xsCols

  const nodeRows = pairsOfNodes.map((pair, i) => {
    return (
      <Row key={i}>
        {pair.map((node, innerMapIndex) => {
          return (
            <Col xs={xsWidth} sm={width} key={innerMapIndex}>
              {node}
            </Col>
          )
        })}
      </Row>
    )
  })

  return (
    <div>
      {nodeRows}
    </div>
  )
}

ItemRow.propTypes = propTypes
ItemRow.defaultProps = defaultProps

export default ItemRow



// WEBPACK FOOTER //
// ./src/components/layout/ItemRow.jsx